import { AxiosError } from 'axios'
import { showToast } from 'shared/ui'
import { logger } from 'shared/lib'
import { SurveysApi } from 'entities/Surveys'
import { SurveysStatus } from 'entities/Surveys/api/types'
import { type SurveySmall } from 'entities/Surveys/model/SurveySmall'
import { type SurveyFull } from 'entities/Surveys/model/SurveyFull'
import { openDisableSurveyModal } from 'pages/surveys/ui/actions/disableSurvey/openDisableSurveyModal'
import { SurveyEnrolmentStore } from 'pages/surveys/ui/SurveyEnrolment'

export const toggleSurveyActive = async (item: SurveySmall | SurveyFull): Promise<void> => {
  const isActive = item.status === SurveysStatus.Active

  if (isActive) {
    openDisableSurveyModal(item.id, (data) => {
      item.setStatus(data.status)
    })
    return
  }

  try {
    const { data } = await SurveysApi.activateSurvey(item.id, { is_active: true })
    item.setStatus(data.status)

    const { data: surveyDetail } = await SurveysApi.getSurvey(data.id)

    const surveyEnrolmentStore = new SurveyEnrolmentStore()
    await surveyEnrolmentStore.init({
      data: {
        name: data.name,
        id: data.id,
        filters: surveyDetail.filters,
      },
    })
  } catch (error) {
    logger.error(error)
    const message = error instanceof AxiosError ? error.errors.getError('message') : null
    showToast({ type: 'error', title: message || 'Something went wrong. Please try again' })
  }
}
